import React, { PureComponent } from 'react'
import { connect } from 'redaction'
import config from 'app-config'

import Box from 'components/layout/Box/Box'
import WidthContainer from 'components/WidthContainer/WidthContainer'

import s from './ErrorContainer.scss'


const isTestApi = config.api === 'test'
const isDevApi  = config.env === 'development'
const isTest    = isTestApi || isDevApi


class ErrorContainer extends PureComponent {

  timeout = null

  state = {
    isAppError: false,
    error: false,
    counter: 60,
  }

  // static getDerivedStateFromError(error) {
  //   return {
  //     isAppError: true,
  //     error,
  //   }
  // }

  componentDidCatch(error) {
    if (!this.timeout) {
      this.setState({
        isAppError: true,
        error,
      })

      this.timeout = setTimeout(() => this.handleTimeout(), 1000)
    }
  }

  componentWillReceiveProps({ pathname }) {
    const { pathname: oldPathname } = this.props

    if (pathname !== oldPathname) {
      this.setState({
        isAppError: false,
      })

      clearTimeout(this.timeout)
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  handleTimeout = () => {
    const { counter } = this.state

    this.setState({
      counter: counter -1,
    })

    if (counter === 1) {
      window.location.reload()
    }
    else {
      this.timeout = setTimeout(() => this.handleTimeout(), 1000)
    }
  }

  render() {
    const { isAppError, error, counter } = this.state
    const { children, pathname } = this.props

    if (isAppError) {
      let message

      if (typeof error === 'string') {
        message = error
      }
      else {
        try {
          message = `${error.message}\n${error.stack}`
        }
        catch (err) {
          message = err
        }
      }

      return (
        <div className={s.container}>
          <WidthContainer>
            <div className={s.text}>ERROR 500</div>
            <Box pt="24">{pathname}</Box>
            <Box pt="24">{message}</Box>
            <Box pt="24">
              <b>Страница обновится через {counter} сек.</b>
            </Box>
          </WidthContainer>
        </div>
      )
    }

    return children
  }
}


export default connect({
  pathname: 'routing.locationBeforeTransitions.pathname',
})(ErrorContainer)